import styled from "styled-components";

export const PoCardItemWrapper = styled.div`
background-color: #ECEFF1;
padding: 12px;
border-radius: 8px;
.cards-title {
  display: grid;
  grid-template-columns: 5fr 7fr 1fr;
  align-items: baseline;
  padding-bottom: 12px;
  border-bottom: 1px solid #E0E0E0;
  .cards-item {
    display: flex;
    flex-direction: column;
    &:nth-child(3){
      justify-content: end;
      align-items: end;
    }
    img{
      width: 16px;
    }
  p {
    font-size: 10px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: ${({ theme }) => theme["secondaryColor"]};
    margin: 0;
    &:not(:last-child){
      color: ${({ theme }) => theme["label-color-new"]};
      font-size: 12px;
    }
}
}
}
.cards-content-wrapper {
    display: grid;
    grid-template-columns: 2fr 2fr 2.5fr 2fr;
    padding-top: 12px;
    .cards-content {
    display: flex;
    flex-direction: column;
    &:not(:last-child){
      border-right: 1px solid #E0E0E0;
    }
    &:not(:first-child){
      padding-left: 8px;
    }
    p {
    margin: 0;
    font-size: 10px;
    font-weight: 600;
    line-height: 16px;
    text-align: left;
    &:not(:last-child){
    font-weight: 400;
    }
}
}
}
.map-btn-wrapper{
    margin-top: 10px;
    padding: 1px 3px;
    font-weight: 400;
    height: 25px;
    width: 100%;
    line-height: 11px;
    font-size: 10px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    border-color: #1565D8;
    color: #1565D8;
    &:not(:first-child){
      background-color: #1565D8;
      color: #fff;
    }
}
.disabled-save-button{
      background: #cccccc;
      color: #666666; 
      cursor: not-allowed; 
      pointer-events: none; 
      margin-top: 10px;
      height: 25px;
      width: 100%;
      padding: 1px 3px;
      font-weight: 400;
      line-height: 11px;
      font-size: 9px;
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
`;